import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { PaySessionStatus } from '../../../smoothr-web-app-core/models/PaySessionStatus';

@Component({
	standalone: false,
	selector: 'app-discounting-blocked-modal',
	templateUrl: './discounting-blocked-modal.component.html',
	styleUrls: ['./discounting-blocked-modal.component.scss'],
})
export class DiscountingBlockedModalComponent {
	private static readonly MODAL_ID = 'discounting-blocked-modal';
	private modalCtrl = inject(ModalController);
	private repositoryService = inject(RepositoryService);

	constructor() {
		// Dismiss automatically as soon as the main participant finished discounting
		// (status change arrives via the pay session socket).
		this.repositoryService.paySessionObservable.pipe(takeUntilDestroyed()).subscribe(async paySession => {
			if (paySession?.status !== PaySessionStatus.DISCOUNTING) {
				await this.modalCtrl.dismiss(null, undefined, DiscountingBlockedModalComponent.MODAL_ID);
			}
		});
	}

	static async show(modalCtrl: ModalController): Promise<void> {
		const modal = await modalCtrl.create({
			id: DiscountingBlockedModalComponent.MODAL_ID,
			component: DiscountingBlockedModalComponent,
			showBackdrop: true,
			backdropDismiss: false,
			cssClass: 'discounting-blocked-sheet',
		});

		await modal.present();
		await modal.onWillDismiss();
	}
}
